import request from './request'

export function uploadVideo(file, onUploadProgress) {
  const formData = new FormData()
  formData.append('file', file)
  return request.post('/api/video/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
    onUploadProgress
  })
}

export function searchVideo(filename) {
  return request.get('/api/video/search', {
    params: { filename }
  })
}

export function getVideoDetail(shareCode) {
  return request.get(`/api/video/info/${shareCode}`)
}

export function deleteVideo(id) {
  return request.delete(`/api/video/${id}`)
}
